import { useCountryConfig } from 'modules/common/hooks/useCountryConfig'
import { useCountryExternalLinks } from 'modules/common/hooks/useCountryExternalLinks'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { Trans } from 'next-i18next'
import { Link } from '../Link/Link'
import { IconInformationSquare } from '../_icons/icons'
import { BannerMessage } from '../_ui/BannerMessage/BannerMessage'

interface Props {
  className?: string
}

export const BetaVersionBannerMessage = ({ className }: Props) => {
  const { t } = useTranslation('common-components')

  const { leadEmail } = useCountryExternalLinks()
  const { whatsAppSupportNumber } = useCountryConfig()

  return (
    <BannerMessage
      className={className}
      type="important"
      icon={<IconInformationSquare />}
    >
      <Trans
        components={{
          mailtoComponent: (
            <Link className="underline" href={`mailto:${leadEmail}`} />
          ),
          whatsAppLinkComponent: (
            <Link
              className="underline"
              href={`https://wa.me/${whatsAppSupportNumber}`}
            />
          ),
        }}
      >
        {t('betaVersionBannerMessage.content', {
          supportEmail: leadEmail,
        })}
        {whatsAppSupportNumber &&
          t('betaVersionBannerMessage.whatsAppSupportNumber', {
            whatsAppSupportNumber,
          })}
      </Trans>
    </BannerMessage>
  )
}
